export default __webpack_public_path__ + "static/media/logo_desktop_whiteV2.9cf2a82b.svg";